module.exports = __webpack_public_path__ + "static/media/bankTransfer.ec47485a.svg";